function searchVendors () {
  const filter = document.getElementById('search-vendors-input').value
  const ul = document.getElementById('vendors-home-list')
  const li = ul.getElementsByTagName('li')
  for (let i = 0; i < li.length; i++) {
    const elemText = li[i].getElementsByTagName('a')[0].text
    li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
  }
}

const searchVendorInput = $('#search-vendors-input')

searchVendorInput.focusin(function () {
  $('#vendors-home-list').fadeIn('fast')
})
searchVendorInput.focusout(function () {
  $('#vendors-home-list').fadeOut(1000)
})
searchVendorInput.on('keyup', function () { searchVendors() })

$('#homeCatList-1 ul.homeCatListTabs li:first-child').addClass('current')
$('#homeCatList-1 .cat-list-tab-wrapper .row:first-child .cat-list-tab-content').addClass('current')
$('#homeCatList-1 ul.homeCatListTabs li').on('click', function () {
  $('#homeCatList-1 .cat-list-tab-wrapper .row:first-child .cat-list-tab-content').removeClass('current')
  var tab_id = $(this).attr('data-tab')
  $('#homeCatList-1 ul.homeCatListTabs li').removeClass('current')
  $('#homeCatList-1 .cat-list-tab-content').removeClass('current')
  $(this).addClass('current')
  $('#homeCatList-1 #'+tab_id).addClass('current')
  return false
})

const inpCopy = document.querySelectorAll('.copyCodeTxt')

inpCopy.forEach(inp => {
  inp.onclick = function () {
    document.execCommand('copy')
    inp.classList.add('active')
    setTimeout(function () {
      inp.classList.remove('active')
    }, 2500)
  }
  inp.addEventListener('copy', function (event) {
    event.preventDefault()
    if (event.clipboardData) {
      event.clipboardData.setData('text/plain', inp.textContent)
      // console.log(event.clipboardData.getData("text"))
    }
  })

})
